module.exports = __webpack_public_path__ + "img/sensor-off.cdeaf975.png";